<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="About" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-input
                  label="Title On Career *"
                  v-model="titleOnCareer"
                  :error="!!errors.about_career_title"
                  :error-messages="errors.about_career_title"
                  @input="delete errors.about_career_title"
                />
                <div style="margin-bottom: 15px;">
                  <span>Description On Career *</span>
                  <ckeditor v-model="descriptionOnCareer" :editor="editor" :config="editorConfig"></ckeditor>
                  <div v-if="errors.about_career_description" style="color: red;">{{ errors.about_career_description[0] }}</div>
                </div>
                <div style="margin-bottom: 15px;">
                  <span>Content On Career *</span>
                  <ckeditor v-model="contentOnCareer" :editor="editor" :config="editorConfig"></ckeditor>
                  <div v-if="errors.about_career_content" style="color: red;">{{ errors.about_career_content[0] }}</div>
                </div>
                <va-card class="mb-3" title="Image On Home">
                  <div v-if="imageOnCareerExisting">
                    <a style="display: block;" target="_blank" :href="imageOnCareerExisting"><img style="max-width: 400px;" :src="imageOnCareerExisting"></a>
                    <div><va-button small color="danger" @click="imageOnCareerExisting = deleteImage(imageOnCareerId, 'about_career_image') ? '' : imageOnCareerExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    @input="delete errors.about_career_image"
                    v-model="imageOnCareer"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('about_career_image', 'about_career_image', imageOnCareer[0])">Завантажити</va-button>
                  <div v-if="errors.about_career_image" style="color: red;">{{ errors.about_career_image[0] }}</div>
                </va-card>
                <va-button
                  @click="validate()"
                >Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue'
import '@ckeditor/ckeditor5-build-classic/build/translations/uk'

export default {
  name: 'grid',
  components: {
    ckeditor: CKEditor.component,
  },
  data () {
    return {
      titleOnCareer: '',
      descriptionOnCareer: '',
      contentOnCareer: '',
      imageOnCareer: [],
      imageOnCareerId: '',
      imageOnCareerExisting: '',

      errors: [],

      editor: ClassicEditor,
      editorConfig: {
        language: 'uk',
        simpleUpload: {
          uploadUrl: `${process.env.VUE_APP_AGRO_API_URL}/admin/editor/upload`,
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        },
      },

      tabTitles: ['Main'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
    putData () {
      return {
        about_career_title: this.titleOnCareer,
        about_career_description: this.descriptionOnCareer,
        about_career_content: this.contentOnCareer,
      }
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    uploadImage (param, key, file, agg = 'about') {
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append(param, file)
      formData.append('lang', this.locale)
      formData.append('aggregate', agg)
      formData.append('key', key)
      formData.append('multiple', '0')
      formData.append('file_id', '0')
      axios.post(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/upload/1?lang=${this.locale}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    async deleteImage (id, fieldKey) {
      return axios.post(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/1/delete-file/${id}?lang=${this.locale}`, {
        key: fieldKey,
      })
        .then(() => {
          this.showToast('Successfully deleted')
        })
        .catch(() => {
          this.showToast('Error')
        })
    },
    submit () {
      axios.put(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/1?lang=${this.locale}`, this.putData)
        .then(response => {
          this.showToast('Successful update')
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
          }
          this.showToast('Error')
        })
    },
    validate () {
      axios.put(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/validate/1?lang=${this.locale}`, this.putData, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(response => {
          this.errors = response.data
          if (!Object.keys(this.errors).length) {
            this.submit()
          }
        })
        .catch(error => {
          console.log(error)
          this.showToast('Validate Fetch Error')
        })
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/1?lang=${this.locale}`)
        .then(response => {
          this.titleOnCareer = response.data.about_career_title
          this.descriptionOnCareer = response.data.about_career_description ? response.data.about_career_description : ''
          this.contentOnCareer = response.data.about_career_content ? response.data.about_career_content : ''
          this.imageOnCareerExisting = response.data.about_career_image ? process.env.VUE_APP_AGRO_ADMIN + response.data.about_career_image : null
          this.imageOnCareerId = response.data.about_career_image_id
        })
        .catch(error => {
          console.log(error.response)
        })
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
